import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AddButton from '../components/buttons/AddButton';
import { withTheme } from 'styled-components'


class PrevButton extends React.Component {

  render() {
    const { onClick, to, disabled, isExam } = this.props;
    let type = undefined;

    if(isExam){
      type = 'prevForm';
    }

    if (onClick) {
      return <AddButton disabled={disabled} onClick={onClick} icon="chevron-left" noTitle backgroundType={type}/>;
    }
    return (
      <Link to={to}>
        <button className="sc-AxiKw coUCbo btn mb-3 ml-3" style={{ backgroundColor: this.props.theme.primary, color: "#ffffff" }}><i className="fas fa-chevron-left" /></button>
      </Link>
    );
  }
};

PrevButton.propTypes = {
  to: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

PrevButton.defaultProps = {
  onClick: null,
  disabled: false,
};

export default withTheme(PrevButton);
